import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
export interface IBreadCrumb {
  title: string,
  url: string
}
@Injectable({
  providedIn: 'root'
})
export class BreadCrumbServiceRight {
  breadCrumbItems: BehaviorSubject<IBreadCrumb[]> = new BehaviorSubject<IBreadCrumb[]>([]);
  breadCrumbItems$: Observable<IBreadCrumb[]> = this.breadCrumbItems.asObservable();

  constructor() {
  }

  public updateBreadCrumb(items: IBreadCrumb[]): void {

    this.breadCrumbItems.next(items);
  }
}
